import { SearchResourceType } from '@app/core/model/search/search-resource-type';
import { SearchResourceDictionaryService } from '@app/core/services/resource-dictionary/search-resource-dictionary.service';
import { SearchQueryService } from '@app/core/services/search/resource-search/search-query.service';
import { BiosampleSearchColumnFields } from '../gridOptions/biosample-search-grid-options-formatter';
import { ISearchDataSourceOptions, SearchDataSource } from './search.datasource';
import { ISearchFilter } from '@app/core/services/search/resource-search/search-query-types.service';

export class BiosampleSearchDataSource extends SearchDataSource {
    constructor(
        searchQueryService: SearchQueryService,
        resourceDictionaryService: SearchResourceDictionaryService,
        dataSourceOptions: ISearchDataSourceOptions
    ) {
        const biosampleResourceDictionary = resourceDictionaryService.getResourceConfigByType(SearchResourceType.Biosample);
        super(searchQueryService, biosampleResourceDictionary, dataSourceOptions);
        
        const filterMethods: {[field: string]: (field: string, filterObj: any) => ISearchFilter} = {
            DefaultProjectName: (field, filterObj) => {
                return {
                    // Mirror legacy biosampleProjectSearch filter (Tang searchFilterDictionary.service.ts):
                    // a biosample can be filtered by its default project OR its output project, OR'd together
                    // into ((DefaultProject.Id:X) OR (OutputProject.Id:X)). Dropping OutputProject.Id would
                    // hide biosamples whose only association with the project is via an output project.
                    facets: ['DefaultProject.Id', 'OutputProject.Id'],
                    currentChoice: {
                        value: filterObj.value,
                        label: null,
                    }
                }
            }
        };

        this.filterMethods = filterMethods as any;
    
    }

    get rawTextFilterColumnName(): string {
        return BiosampleSearchColumnFields.Name;
    }
}
